module.exports = __webpack_public_path__ + "static/marlen_portrait-1ac57cdcac1c2aa95eb6de12ac2e2047.jpg";